<template>
  <div class="page flex-col">
    <div class="wrap1 flex-col">
      <!-- <img
        class="img1"
        referrerpolicy="no-referrer"
        src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngad5f0d35d719a5e8e532d9026a1423ccdd763d660c0787a153fa85932c23e026"
      /> -->
    </div>
    <div class="wrap2">
      <div class="rimg"></div>
      <div class="lbox">
        <div class="layer1 flex-row">
          <div v-if="type != 3" class="outer1">微信登録更快捷</div>
          <div class="outer2">
            <img
              class="label1"
              style="cursor: pointer"
              @click="weixinLogin"
              referrerpolicy="no-referrer"
              :src="
                type == 3
                  ? './static/login/computer.png'
                  : './static/login/code.png'
              "
            />
          </div>
        </div>
        <div v-if="type === 2" class="layer2 flex-row phonebox">
          <el-input
            v-model="form.mobile"
            placeholder="請輸入手機號"
            class="input-with-select"
          >
            <el-select v-model="ac" slot="prepend" class="ac-ipt" size="small">
              <el-option
                v-for="item in codeList"
                :key="item"
                :value="item"
                :label="'+' + item"
              />
            </el-select>
            <!-- <el-select v-model="select" slot="prepend" placeholder="请选择">
              <el-option label="餐厅名" value="1"></el-option>
              <el-option label="订单号" value="2"></el-option>
              <el-option label="用户电话" value="3"></el-option>
            </el-select> -->
          </el-input>
        </div>
        <div v-if="type === 2" class="layer3 flex-row imgcodebox">
          <el-input
            style="width: 65%"
            v-model="form.code"
            class="ipt-margin"
            placeholder="請輸入圖片驗證碼"
          >
            <!-- <img :src="captchaData" slot="append" @click="getImg" /> -->
          </el-input>
          <el-button
            slot="append"
            :style="{
              background: `url(${captchaData}) no-repeat 40% 50% / 110% 110% `,

              width: '110px',
            }"
            @click="getImg"
          ></el-button>
        </div>
        <div
          v-if="type === 2"
          class="layer3 flex-row"
          style="position: relative"
        >
          <el-input
            v-model="form.smsCode"
            placeholder="請輸入短信驗證碼"
          ></el-input>
          <el-button
            style="position: absolute; right: 10px; top: 5px"
            @click="getSMS"
            type="text"
            >{{ text }}</el-button
          >
        </div>
        <div class="layer3 flex-row" v-if="bindchecked">
          <el-input v-model="form.cardNo" placeholder="請输入集團閱讀卡號">
          </el-input>
        </div>

        <div class="layer4 flex-row align-center">
          <el-checkbox v-model="bindchecked">綁定集團閲讀卡</el-checkbox>
        </div>
        <!-- <div class="layer4 flex-row align-center">
        <el-checkbox v-model="checked">升级为会员</el-checkbox>
      </div>
      <div class="layer5 flex-row">
        <button class="section1 flex-col" @click="onClick_1">
          <span class="word7">登录</span>
        </button>
      </div> -->
        <div style="font-size: 20px" v-if="type === 3">
          <!-- <div
            class="flex-row justify-between align-center"
            style="
              padding-top: 30px;
              padding-bottom: 20px;
              padding-left: 30px;
              padding-right: 30px;
              width: 100%;
            "
          >
            <i
              style="cursor: pointer"
              @click="type = 2"
              class="el-icon-arrow-left"
            ></i>
            <i
              style="cursor: pointer"
              @click="type = 2"
              class="el-icon-close"
            ></i>
          </div> -->
          <wxlogin
            appid="wxb65ac338c095245b"
            :scope="'snsapi_login'"
            :theme="'black'"
            :redirect_uri="redirectUrl"
          >
          </wxlogin>
          <!-- <span style="margin-top: 20px; margin-bottom: 20px; font-size: 18px"
        >使用微信扫码登录</span
      > -->
          <!-- <div style="color: #bcbcbc; font-size: 14px">
        没有账号？<span style="color: #aa1d1f">立即注册</span>
      </div> -->
        </div>

        <div class="layer4 flex-row align-center">
          <el-checkbox class="checked" v-model="checked"
            ><span class="bfore">同意并閲讀</span
            >使用條款與隱私政策</el-checkbox
          >
        </div>
        <div class="layer5 flex-row" v-if="type != 3">
          <!-- <el-button
          class="login flex-col center"
          type="primary"
          @click="onClick_1"
        >
          登録/注册
        </el-button> -->
          <button class="section1 flex-col" @click="onClick_1">
            <span class="word7">登録/注册</span>
          </button>
        </div>

        <div class="layer6 flex-row justify-between">
          <span v-if="type === 3" @click="type = 2" class="info5"
            >手機登録</span
          >
          <span v-if="type === 2" @click="type = 3" class="info5"
            >微信登録</span
          >
          <!-- <span class="word8">立即注册</span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from "@/utils/eventBus.js"
// import VueQr from "vue-qr"
import wxlogin from "@/components/sel-wxlogin"
import {
  read,
  smsCode,
  smsLogin,
  bookInfo,
  bookPage,
  getCaptchaImg,
  getPhoneCode,
  getInfo,
  wxLogin
} from "@/api/api"

export default {
  name: "loginBox",
  components: {
    // VueQr,
    wxlogin
  },
  // props: ['loginDialogVisible'],
  data () {
    return {
      // dialogVisible: true,
      // dialogFormVisible: true,//绑定手机号对话框
      // showClose: false,
      // modal: false,
      phoneplaceholder: '        請輸入手機號',
      ac: '86',
      select: '',
      logoSrc: "",
      text: "獲取驗證碼",
      form: {
        mobile: "",
        smsCode: "",
        cardNo: "",
        code: ""
      },

      type: 2, //3微信登录
      constants: {},
      checked: true,
      bindchecked: false,
      timer: null,
      captchaData: "",
      codeList: ["86", "852"],
      redirectUrl: encodeURIComponent('https://www.dclib.cn/#/'),
      state: '',
      userinfo: {}
    }
  },
  created () {


    // 微信登录
    eventBus.$on("WeiLogin", (code) => {
      wxLogin({ code: code, cardNo: this.form.cardNo }).then(
        res => {

          if (res.code === 200) {
            // localStorage.setItem("token", "Bearer " + res.token)
            // eventBus.$emit("getUserInfo")
            // eventBus.$emit("doChangeloginVisible", false)
            // this.noparam()
            // this.$message.success("登録成功")
            // if (this.$route.path == '/login') {
            //   this.$router.replace({
            //     path: this.$route.query.forword ? this.$route.query.forword : '/'
            //   })
            // } else if (this.$route.path == '/search') {
            //   this.$bus.$emit("reloadSearch", true)
            // } else {
            //   location.reload()
            // }
            this.login(res)



          } else {
            this.$message.error(res.msg)
          }
        }
      )

    }),
      eventBus.$on("noparam", () => {
        this.noparam()
      })

  },
  mounted () {

    this.logoSrc = require("@/assets/wx.png")
    this.getImg()
    getPhoneCode().then(res => {
      if (res.code == 200) {
        this.codeList = res.data
        this.ac = this.codeList[0]
      }

    })
    localStorage.setItem('forword', this.$route.query.forword ? this.$route.query.forword : "/")
    // this.state = parseInt(new Date().getTime() / 100).toString
    // console.log(localStorage.forword)
  },
  methods: {

    weixinLogin () {

      this.type = (this.type == 3) ? 2 : 3

    },
    noparam () {
      this.form.mobile = ''
      this.form.code = ''
      this.form.smsCode = ''
      this.form.cardNo = ''
      this.form.uuid = ''
      this.getImg()
    },
    // openLoginDialogBox (val) {
    //   console.log(val, 'val')
    //   this.dialogVisible = val

    // },

    weixinLogin () {

      this.type = (this.type == 3) ? 2 : 3

    },

    getImg () {
      getCaptchaImg().then(res => {
        this.captchaData = "data:image/png;base64," + res.img
        this.form.uuid = res.uuid
      })
    },
    getSMS () {
      if (!/^[1][35789][0-9]{9}$/.test(this.form.mobile)) {
        // console.log(this.form.mobile, 'this.form.mobile')
        // if (!/^[0-9]*$/.test(this.form.mobile)) {
        this.$message.error("請輸入正確手機號")
        return
      }
      // if (!this.form.code) {
      //   this.$message.error("請輸入圖片驗證碼")
      //   return
      // }

      if (this.text === "獲取驗證碼") {
        smsCode({
          mobile: this.ac + this.form.mobile,
          uuid: this.form.uuid,
          code: this.form.code,
          scene: "LOGIN"
        }).then(res => {
          if (res.code == 500) {
            this.$message.error(res.msg)
            this.getImg()
            return
          }
          let num = 60
          this.timer = setInterval(() => {
            num--

            if (num === 0) {
              clearInterval(this.timer)
              this.timer = null
              this.text = `獲取驗證碼`
            }
            else {
              this.text = `重新獲取(${num}s)`
              // console.log(num,'num');
            }
          }, 1000)

          this.form.uuid = res.uuid
          // this.form.smsCode = res.smsCode
        })
      } else {
      }
    },
    onClick_1 () {
      if (!this.checked) {
        this.$message.warning("請先閱讀條款並同意勾選")
        return
      }
      if (!this.form.mobile) {
        this.$message.error("請輸入手機號")
        return
      }
      if (!/^[1][35789][0-9]{9}$/.test(this.form.mobile)) {
        // if (!/^[0-9]*$/.test(this.form.mobile)) {
        this.$message.error("請輸入正確手機號")
        return
      }
      if (!this.form.smsCode) {
        this.$message.error("請輸入驗證碼")
        return
      }
      smsLogin({ ...this.form, mobile: this.ac + this.form.mobile }).then(
        res => {
          this.login(res)
        }
      )
    },
    //微信登录
    // WXLogin (code) {
    //   // console.log(code, 'code')
    //   wxLogin({ code: code, cardNo: this.form.cardNo }).then(
    //     res => {
    //       console.log(res, 'res')
    //       this.login(res)
    //     }
    //   )
    // },
    // localStorage.cardNo ? localStorage.cardNo : ''


    login (res) {
      if (res.code === 200) {
        // localStorage.setItem("token", "Bearer " + res.token)
        // eventBus.$emit("getUserInfo")
        // this.$message.success("登録成功")
        // this.$router.replace({
        //   path: this.$route.query.forword ? this.$route.query.forword : "/"
        // })
        localStorage.setItem("token", "Bearer " + res.token)
        eventBus.$emit("getUserInfo")
        // eventBus.$emit("doChangeloginVisible", false)
        eventBus.$emit('outLogin', 1)
        this.noparam()
        this.$message.success("登録成功")
        if (this.$route.path == '/login') {
          this.$router.replace({
            path: this.$route.query.forword ? this.$route.query.forword : '/'
          })
        }
        // else if (this.$route.path == '/search') {
        //   this.$bus.$emit("reloadSearch", true)
        // }
        else {
          location.reload()
        }


        // eventBus.$emit("openBindMobile")


      } else {
        this.$message.error(res.msg)
      }
    },


  },
  // watch: {
  //   $route (to, from) {
  //     // console.log(to, from, 'tofrom')
  //     let isLogin = localStorage.getItem("token") ? true : false
  //     let code = this.$route.query.code
  //     if (code && !isLogin) {
  //       this.WXLogin(code)

  //     }
  //   }
  // }
  // watch: {
  //   'form.cardNo': {
  //     handler (newVal, oldVal) {
  //       localStorage.setItem('cardNo', newVal)
  //     },
  //     deep: true
  //   },
  //   bindchecked (newV, oldV) {
  //     if (!newV) {
  //       localStorage.setItem('cardNo', '')
  //       this.form.cardNo = ''
  //     }
  //   }


  // }
  beforeDestroy () {
    eventBus.$off("WeiLogin")
    eventBus.$off("noparam")
  }

}


</script>


<style lang="less" scoped>
/deep/.el-button--primary.is-plain {
  border: white;
  background: none;
}
/deep/.phonebox .el-input__inner:nth-child(2) {
  padding-left: 80px;
}
/deep/.el-input-group__append,
/deep/.el-input-group__prepend {
  border: none;
  background-color: white;
  position: absolute;
  left: 5px;
  top: 10px;
}
/deep/.el-select .el-input {
  width: 80px;
}
/deep/.imgcodebox {
  justify-content: space-between;
}
/deep/.impowerBox .qrcode {
  width: 186px;
}
.bfore {
  color: #a6a6a6;
}
/deep/.el-checkbox__inner {
  border: 1px solid #9b0000;
}
/deep/.el-checkbox__label {
  color: #9b0000;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #9b0000;
  border-color: #9b0000;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #9b0000;
}

/deep/ .el-checkbox.is-bordered.is-checked {
  border-color: #9b0000;
}

/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #9b0000;
}

/deep/ .el-input__inner {
  border-radius: 26px;
  height: 52px;
  border: 1px solid #dddddd;
}

/* 谷歌 */
/deep/ .el-input__inner::-webkit-input-placeholder {
  color: #454545;
  font-weight: 600;
}

/* 火狐 */
/deep/ .el-input__inner:-moz-placeholder {
  color: #454545;
  font-weight: 600;
}

/*ie*/
/deep/ .el-input__inner:-ms-input-placeholder {
  color: #454545;
  font-weight: 600;
}

/* //获取焦点时的颜色 */
/deep/ .el-input__inner:focus::-webkit-input-placeholder {
  color: #454545;
  font-weight: 600;
}

/deep/ .el-input__inner:focus::-moz-input-placeholder {
  color: #454545;
  font-weight: 600;
}

/deep/ .el-input__inner:focus::-ms-input-placeholder {
  color: #454545;
  font-weight: 600;
}

html {
  font-size: 37.5px;
}

.page {
  width: 100%;
  position: relative;
  height: 24.187rem;
  background-color: rgba(245, 245, 245, 1);
  overflow: hidden;
  margin: 0 auto;
}

.wrap1 {
  height: 24.187rem;
}

.mod1 {
  height: 2.08rem;
  background-color: rgba(255, 255, 255, 1);
  padding: 0.507rem 0 0 2.987rem;
}

.group1 {
  width: 32.214rem;
  height: 1.307rem;
}

.bd1 {
  width: 4.534rem;
  height: 1.307rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng4763fecae4f3dbd33fedecbd4a2e0fc03f75b4cd8e9d4e000fe793b5c88589d4)
    0.187rem 0rem no-repeat;
  background-size: 4.347rem 1.334rem;
}

.bd2 {
  height: 0.827rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng6bf1dc9e05e2fcfc42219f92ddbe5dd7fc853ba61295d528ec2d1b0b07003555)
    100% no-repeat;
  width: 3.467rem;
  margin: 0.134rem 0 0 2.8rem;
  padding: 0.16rem 0 0 1.28rem;
}

.word1 {
  width: 0.88rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.word2 {
  width: 1.734rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.494rem;
}

.info1 {
  width: 1.734rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.494rem;
}

.word3 {
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.494rem;
}

.txt1 {
  width: 1.494rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangTC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 1.52rem;
}

.bd3 {
  width: 0.427rem;
  height: 0.587rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng5618ba96d6e45c5af5d14cae1dcfca8615fc726c6816559d10f2f2d325c1d304)
    100% no-repeat;
  margin: 0.24rem 0 0 6.214rem;
}

.word4 {
  width: 0.747rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 0.214rem;
}

.bd4 {
  width: 0.027rem;
  height: 0.427rem;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng292e16e315659a9700abfa430c040d1419bc4573dc009e320d08121fccd7eb1f)
    0rem 0rem no-repeat;
  background-size: 0.027rem 0.454rem;
  margin: 0.347rem 0 0 0.294rem;
}

.txt2 {
  width: 0.747rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Medium;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
  margin: 0.294rem 0 0 0.294rem;
}

.img1 {
  width: 38.4rem;
  height: 11.44rem;
  margin-top: 8.534rem;
}

.mod2 {
  width: 38.4rem;
  height: 0.134rem;
  background-color: rgba(170, 29, 31, 1);
  margin: 0;
}

.mod3 {
  z-index: 4;
  height: 2rem;
  overflow: hidden;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng2dc70e2dd957c588ff9bfdb344f8935d1e22f4b76f2bdd7091a344d1f294119c)
    100% no-repeat;
  width: 38.4rem;
  position: relative;
  padding: 0.747rem 0 0 16.187rem;
  margin: 0;
}

.word5 {
  z-index: 7;
  position: static;
  left: 16.187rem;
  top: 22.934rem;
  width: 6.054rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.373rem;
  font-family: PingFangTC-Regular;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.pic1 {
  z-index: 5;
  position: absolute;
  left: 0;
  top: 0;
  width: 38.4rem;
  height: 2rem;
}

.wrap2 {
  z-index: 10;
  // height: 12.56rem;
  width: 980px;
  height: auto;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 9px 17px 0px rgba(188, 188, 188, 0.5);
  // width: 12.56rem;
  position: absolute;
  /* left: 12.907rem; */
  left: 50%;
  transform: translateX(-50%);
  top: 5.334rem;
  display: flex;
  justify-content: space-between;
  .rimg {
    width: 370px;
    background: url("/static/login/loginboxbg.png") no-repeat;
    background-size: auto 100%;
  }
  .lbox {
    flex: 1;
    padding: 25px 50px 0 0;
  }
}

.layer1 {
  // width: 6.347rem;
  // height: 2.187rem;
  // margin: 0.4rem 0 0 5.627rem;
  // text-align: right;
  display: flex;
  justify-content: right;
  align-items: flex-end;
}

.outer1 {
  font-size: 14px;
  height: 34px;
  border-radius: 17px;
  padding: 0 10px;
  border: 1px solid #d2d2d2;
  line-height: 34px;
  // color: #606266;
}

.outer2 {
  z-index: 33;
  position: relative;
  width: 1.12rem;
  height: 1.227rem;
  overflow: hidden;
  // background: url(/static/login/code.png) 0rem -0.027rem no-repeat;
  // background-size: 1.12rem 1.227rem;
}

.label1 {
  z-index: 34;
  position: absolute;
  left: 0;
  top: -0.026rem;
  width: 1.12rem;
  height: 1.227rem;
}

.layer2 {
  width: 9.147rem;
  height: 1.387rem;
  margin: 1.04rem 0 0 1.707rem;
}

.main1 {
  height: 1.387rem;
  border-radius: 26px;
  border: 1px solid rgba(221, 221, 221, 1);
  background-color: rgba(255, 255, 255, 1);
  padding-left: 0.72rem;
  width: 9.147rem;
}

.info2 {
  width: 1.867rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(69, 69, 69, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.layer3 {
  width: 9.147rem;
  height: 1.387rem;
  margin: 0.694rem 0 0 1.707rem;
}

.bd5 {
  height: 1.387rem;
  border-radius: 26px;
  border: 1px solid rgba(221, 221, 221, 1);
  background-color: rgba(255, 255, 255, 1);
  padding-left: 0.72rem;
  width: 9.147rem;
}

.info3 {
  width: 1.867rem;
  height: 0.534rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(69, 69, 69, 1);
  font-size: 0.373rem;
  font-family: PingFangSC-Semibold;
  white-space: nowrap;
  line-height: 0.534rem;
  text-align: left;
}

.layer4 {
  width: 8.64rem;
  height: 0.587rem;
  margin: 0.587rem 0 0 1.84rem;
}

.label2 {
  width: 0.587rem;
  height: 0.587rem;
}

.word6 {
  width: 1.6rem;
  height: 0.454rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(38, 38, 38, 1);
  font-size: 0.32rem;
  white-space: nowrap;
  line-height: 0.454rem;
  text-align: left;
  margin: 0.08rem 0 0 0.187rem;
}

.info4 {
  cursor: pointer;
  display: block;
  overflow-wrap: break-word;
  color: rgba(166, 166, 166, 1);
  font-size: 0.32rem;
  white-space: nowrap;
  text-align: left;
  margin: 0rem 0 0 4.987rem;
}

.layer5 {
  width: 9.147rem;
  height: 1.52rem;
  margin: 0.694rem 0 0 1.707rem;
}

.section1 {
  height: 1.52rem;
  border-radius: 28.5px 28.5px 28.5px 28.5px;
  background-color: rgba(170, 29, 31, 1);
  width: 9.147rem;
  padding: 0.43rem 0 0 3.6rem;
  cursor: pointer;
}

.word7 {
  width: 0.854rem;
  height: 0.587rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 0.426rem;
  font-family: PingFangSC-Semibold;
  white-space: nowrap;
  line-height: 0.587rem;
  text-align: left;
}

.layer6 {
  width: 8.827rem;
  height: 0.454rem;
  margin: 0.48rem 0 1.147rem 1.707rem;
}

.info5 {
  cursor: pointer;
  width: 1.6rem;
  height: 0.454rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(166, 166, 166, 1);
  font-size: 0.32rem;
  white-space: nowrap;
  line-height: 0.454rem;
  text-align: left;
}

.word8 {
  width: 1.28rem;
  height: 0.454rem;
  display: block;
  overflow-wrap: break-word;
  color: rgba(170, 29, 31, 1);
  font-size: 0.32rem;
  white-space: nowrap;
  line-height: 0.454rem;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/logindialog.vue